/**
 * A link in an old answer that points at a document page (built by
 * linkLegacyReferences, it carries `msg_id`) opens in the PDF viewer at that
 * page, as the old chat did. Returns whether it handled the link.
 */
export const openLegacyDocumentLink = (href: string): boolean => {
  if (!href.includes('msg_id=')) return false;
  const questionMark = href.indexOf('?');
  let path = href;
  let page: string | null = null;
  if (questionMark !== -1) {
    const params = new URLSearchParams(href.slice(questionMark + 1));
    page = params.get('page');
    const kept = new URLSearchParams();
    for (const [key, value] of params.entries()) {
      if (!['id', 'index', 'msg_id', 'ref', 'page'].includes(key)) {
        kept.append(key, value);
      }
    }
    path = href.slice(0, questionMark) + (kept.toString() ? `?${kept}` : '');
  }
  window.open(
    `/pdfViewer/web/viewer.html?file=${encodeURIComponent(path)}&force=true&skipUnsavedConfirm=true${page ? `#page=${page}` : ''}`,
    '_blank',
    'noopener,noreferrer',
  );
  return true;
};
